<script lang="ts">
  import { getMediaQuery } from "$utils/mediaQuery";
  import Button, { type ButtonVariants } from "$components/+design-system/Button/Button.svelte";
  import ToolTip from "$components/+shared/ToolTip/ToolTip.svelte";
  import IconButton, {
    type IconButtonSizes,
    type IconButtonVariants,
  } from "$components/+design-system/IconButton/IconButton.svelte";
  import type { IconType } from "$components/+shared/OVIcon/OVIcon";

  export let variant: IconButtonVariants & ButtonVariants = "primary";
  // Button props
  export let label: string;
  export let additionalClassNamesButton: string = "";
  // IconButton props
  export let iconRight: IconType | undefined = undefined;
  export let iconLeft: IconType | undefined = undefined;
  export let size: IconButtonSizes = "medium";
  export let a11yLabel: string;
  export let additionalClassNamesIconButton: string = "";

  const isTabletAndDesktop = getMediaQuery("tablet");

  let icon: IconType | undefined = iconRight || iconLeft;
</script>

{#if $isTabletAndDesktop}
  <ToolTip>
    <span slot="tip">{a11yLabel}</span>
    <div class={additionalClassNamesButton}>
      <Button {label} {variant} {size} {iconLeft} {iconRight} on:click />
    </div>
  </ToolTip>
{:else if icon}
  <div class={additionalClassNamesIconButton}>
    <IconButton {variant} {icon} {a11yLabel} size="large" on:click />
  </div>
{/if}
